import React from 'react';
import { NavLink } from 'react-router-dom';

import { Typography } from 'antd';

const isExternalUrl = (url: string) => /^https?:\/\//.test(url);

interface IProps {
  link: string;
  children: React.ReactNode;
  className: string;
}

export const Link = ({ link, children, ...rest }: IProps) => {
  return isExternalUrl(link) ? (
    <Typography.Link href={link} target='_blank' rel='noopener noreferrer' {...rest}>
      {children}
    </Typography.Link>
  ) : (
    <NavLink to={link} {...rest}>
      {children}
    </NavLink>
  );
};
